// extracted by mini-css-extract-plugin
export default {"cls1":"Base-cls1__db42aa990b61c82776be","cls2":"Base-cls2__c62b318697c41f91a6b4 Base-cls1__db42aa990b61c82776be"};